<div class="download-app-banner">
  <div class="download-app-container">
    <h4>Download the free SonderMind mobile app</h4>

    <iris-button
      [buttonType]="buttonTypes.PRIMARY"
      [linkHref]="downloadAppLink"
      [target]="target.BLANK"
      [iconPosition]="iconPositions.RIGHT"
      class="custom-download-btn"
    >
      Download the App
      <iris-icon
        name="arrow_line_right"
        [size]="iconSizes.SM"
        [color]="iconColors.WHITE"
      >
      </iris-icon>
    </iris-button>
  </div>

  <div class="download-app-image">
    <img src="/assets/download-app.png" alt="Mobile App" />
  </div>
</div>
